module.exports = __webpack_public_path__ + "static/media/icon-eye.87037d0d.png";